export const EMAIL_CHANGE = 'ExportModal/email-change';
export const OPEN = 'ExportModal/open';
export const SELECTION_SET = 'ExportModal/selection-set';
export const SHOW = 'ExportModal/show';
export const EXPORT_RESULT_SET = 'ExportModal/export-result-set';
export const IS_LOADING_STATE_SET = 'ExportModal/is-loading-state-set';
export const IS_EXPORT_STATE_SET = 'ExportModal/is-export-state-set';
export const SET_EXPORT_TYPE = 'ExportModal/set-type-of-export';
export const RESET_EXPORT_TYPE = 'ExportModal/reset-type-of-export';
